import {
  Button,
  Card,
  Label,
  Stack,
  TextField,
  Text,
} from "@towersystems/roam-common-native";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { CreateVariantChildFormValues } from "./types";
import { toTitleCase } from "@towersystems/roam-common/lib/shared-utils";
import { View } from "react-native-ui-lib";
import { CreateVariantChildFormProvider } from "./CreateVariantChildFormProvider";
import { Ionicons } from "@expo/vector-icons";
import React from "react";

export interface CreateVariantChildFormProps {
  onGenerateBarcodePress?: () => Promise<string | undefined | void>;
}

export const CreateVariantChildForm = ({
  onGenerateBarcodePress,
}: CreateVariantChildFormProps) => {
  const { control, setValue, formState } =
    useFormContext<CreateVariantChildFormValues>();

  const { errors } = formState;
  const { fields } = useFieldArray({
    control: control,
    name: "selectedOptions",
  });

  const handleOnGenerateBarcodePress = React.useCallback(async () => {
    if (!onGenerateBarcodePress) {
      return;
    }

    const barcode = await onGenerateBarcodePress();
    if (barcode) {
      setValue("stockNumber", barcode, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [setValue, onGenerateBarcodePress]);

  const trailingMarkup = onGenerateBarcodePress ? (
    <Button size="compact" onPress={handleOnGenerateBarcodePress}>
      <Text color="action">
        <Ionicons name="barcode" size={24} />
      </Text>
    </Button>
  ) : undefined;

  return (
    <Stack vertical>
      <Card title="Variant Details">
        <View>
          <Label required label="Barcode"></Label>
          <Controller
            name="stockNumber"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                value={value ?? ""}
                onChangeText={onChange}
                validationMessage={
                  error
                    ? error.message
                    : errors.root?.stockNumber?.message ?? undefined
                }
                placeholder="Enter a barcode"
                trailingAccessory={trailingMarkup}
              />
            )}
          />
        </View>
      </Card>
      <Card title="Variant Options">
        <Stack vertical>
          {fields.map((field, index) => {
            return (
              <View>
                <Label required label={toTitleCase(field.name)}></Label>
                <Controller
                  name={`selectedOptions.${index}.value` as const}
                  control={control}
                  render={({
                    field: { onChange, value, onBlur },
                    fieldState: { error },
                  }) => (
                    <TextField
                      onBlur={onBlur}
                      value={value ?? ""}
                      onChangeText={onChange}
                      validationMessage={error ? error.message : undefined}
                      placeholder="Enter a value"
                    />
                  )}
                />
              </View>
            );
          })}
        </Stack>
      </Card>
    </Stack>
  );
};

CreateVariantChildForm.CreateVariantChildFormProvider =
  CreateVariantChildFormProvider;
